// Via: https://stackoverflow.com/a/64385113/3423324#is-it-possible-to-remove-a-prefers-color-scheme-event-listener-in-vue
// Source: https://jsfiddle.net/ejaf7c1w/
// Rewritten for Vue 3 with Composition API and Typescript by luckydonald.

import type { Ref } from "vue";
import { ref, onMounted, nextTick, onBeforeUnmount } from "vue";

export const addDarkmodeListener = (): Ref<boolean> => {
  const darkmodeEnabled = ref(
    matchMedia("(prefers-color-scheme: dark)").matches
  );
  const media = ref<MediaQueryList | null>(null);

  const setDarkMode = ({ matches }: { matches: boolean }) => {
    darkmodeEnabled.value = matches;
  };

  onMounted(async () => {
    media.value = matchMedia("(prefers-color-scheme: dark)");
    await nextTick();
    // DOM is now updated
    if (media.value !== null) {
      media.value.addEventListener("change", setDarkMode);
    }
  });

  onBeforeUnmount(() => {
    if (media.value !== null) {
      media.value.removeEventListener("change", setDarkMode);
    }
  });
  return darkmodeEnabled;
};
